"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BSV20V2 = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-escape */
const scrypt_ts_1 = require("scrypt-ts");
const ordinal_1 = require("./ordinal");
const utils_1 = require("../utils");
/**
 * A base class implementing the bsv20 v2 protocol
 */
class BSV20V2 extends scrypt_ts_1.SmartContract {
    constructor(id, sym, max, dec) {
        super(...arguments);
        this.max = max;
        this.dec = dec;
        this.id = id;
        this.sym = sym;
        (0, scrypt_ts_1.assert)(this.max <= 18446744073709551615n);
        (0, scrypt_ts_1.assert)(this.dec <= 18);
    }
    buildStateOutputFT(amt) {
        if (this.isGenesis()) {
            this.initId();
        }
        const stateScript = BSV20V2.createTransferInsciption(this.id, amt) +
            ordinal_1.Ordinal.removeInsciption(this.getStateScript());
        return scrypt_ts_1.Utils.buildOutput(stateScript, 1n);
    }
    isGenesis() {
        return this.id === (0, scrypt_ts_1.toByteString)('');
    }
    static buildTransferOutput(address, id, amt) {
        const transferScript = BSV20V2.buildTransferScript(address, id, amt);
        return scrypt_ts_1.Utils.buildOutput(transferScript, 1n);
    }
    static buildTransferScript(address, id, amt) {
        return (BSV20V2.createTransferInsciption(id, amt) +
            scrypt_ts_1.Utils.buildPublicKeyHashScript(address));
    }
    static createTransferInsciption(id, amt) {
        const amtByteString = ordinal_1.Ordinal.int2Str(amt);
        const transferJSON = (0, scrypt_ts_1.toByteString)('{"p":"bsv-20","op":"transfer","id":"', true) +
            id +
            (0, scrypt_ts_1.toByteString)('","amt":"', true) +
            amtByteString +
            (0, scrypt_ts_1.toByteString)('"}', true);
        return ordinal_1.Ordinal.createInsciption(transferJSON, (0, scrypt_ts_1.toByteString)('application/bsv-20', true));
    }
    initId() {
        this.id =
            ordinal_1.Ordinal.txId2str(this.ctx.utxo.outpoint.txid) +
                (0, scrypt_ts_1.toByteString)('_', true) +
                ordinal_1.Ordinal.int2Str(this.ctx.utxo.outpoint.outputIndex);
    }
    getTokenId() {
        if (this.id) {
            return (0, utils_1.fromByteString)(this.id);
        }
        const nop = this.getPrependNOPScript();
        if (nop) {
            const bsv20 = ordinal_1.Ordinal.getBsv20(nop, false);
            if (bsv20.op === 'deploy+mint') {
                return `${this.utxo.txId}_${this.utxo.outputIndex}`;
            }
            else {
                return bsv20.id;
            }
        }
        throw new Error('token id is not initialized!');
    }
    async deployToken(metaInfo) {
        if (this.id !== (0, scrypt_ts_1.toByteString)('')) {
            throw new Error('contract instance to deploy token should not have a id!');
        }
        this.prependNOPScript(ordinal_1.Ordinal.createDeployV2((0, utils_1.fromByteString)(this.sym), this.max, this.dec, metaInfo));
        const tx = await this.deploy(1);
        return `${tx.id}_0`;
    }
    setAmt(amt) {
        const id = this.getTokenId();
        if (!id) {
            throw new Error('no token id!');
        }
        this.prependNOPScript(ordinal_1.Ordinal.createTransferV2((0, utils_1.fromByteString)(this.id), amt));
        return this;
    }
    getAmt() {
        const nopScript = this.getPrependNOPScript();
        if (nopScript === null) {
            throw new Error('no amt setted!');
        }
        return ordinal_1.Ordinal.getAmtV2(nopScript);
    }
    getDefaultTxBuilder(methodName) {
        return async function (current, options, ...args) {
            const recipients = (options.transfer || []);
            const tokenChangeAmt = Array.isArray(recipients)
                ? current.getAmt() -
                    recipients.reduce((acc, receiver) => {
                        return (acc += receiver.amt);
                    }, 0n)
                : current.getAmt() - recipients.amt;
            if (tokenChangeAmt < 0n) {
                throw new Error(`Not enough tokens`);
            }
            // bsv change address
            const changeAddress = await current.signer.getDefaultAddress();
            const nexts = [];
            const tx = new scrypt_ts_1.bsv.Transaction();
            tx.addInput(current.buildContractInput());
            function addReceiver(receiver) {
                if (receiver.instance instanceof BSV20V2) {
                    receiver.instance.setAmt(receiver.amt);
                }
                else {
                    throw new Error('unsupport receiver!');
                }
                tx.addOutput(new scrypt_ts_1.bsv.Transaction.Output({
                    script: receiver.instance.lockingScript,
                    satoshis: 1,
                }));
                nexts.push({
                    instance: receiver.instance,
                    balance: 1,
                    atOutputIndex: nexts.length,
                });
            }
            if (Array.isArray(recipients)) {
                for (let i = 0; i < recipients.length; i++) {
                    const receiver = recipients[i];
                    addReceiver(receiver);
                }
            }
            else {
                addReceiver(recipients);
            }
            if (tokenChangeAmt > 0n && options.skipTokenChange !== true) {
                const tokenChangeAddress = options.tokenChangeAddress
                    ? options.tokenChangeAddress
                    : await current.signer.getDefaultAddress();
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const { BSV20V2P2PKH } = require('./bsv20V2P2PKH');
                const p2pkh = new BSV20V2P2PKH((0, scrypt_ts_1.toByteString)(current.getTokenId(), true), current.sym, current.max, current.dec, (0, scrypt_ts_1.Addr)(tokenChangeAddress.toByteString()));
                p2pkh.setAmt(tokenChangeAmt);
                tx.addOutput(new scrypt_ts_1.bsv.Transaction.Output({
                    script: p2pkh.lockingScript,
                    satoshis: 1,
                }));
                nexts.push({
                    instance: p2pkh,
                    balance: 1,
                    atOutputIndex: nexts.length,
                });
            }
            const feePerKb = await current.provider?.getFeePerKb();
            tx.feePerKb(feePerKb);
            tx.change(changeAddress);
            if (options.sequence !== undefined) {
                tx.setInputSequence(0, options.sequence);
            }
            if (options.lockTime) {
                const _sequence = options.sequence !== undefined
                    ? options.sequence
                    : 0xfffffffe;
                tx.setInputSequence(0, _sequence); // activate locktime interlock
                tx.setLockTime(options.lockTime);
            }
            return Promise.resolve({
                tx,
                atInputIndex: 0,
                nexts: nexts,
            });
        };
    }
    static fromUTXO(utxo) {
        if (utxo.satoshis !== 1) {
            throw new Error('invalid ordinal bsv20 utxo');
        }
        const ins = ordinal_1.Ordinal.getInsciptionScript(utxo.script);
        if (!ins) {
            throw new Error('invalid ordinal bsv20 utxo');
        }
        const nopScript = scrypt_ts_1.bsv.Script.fromHex(ins);
        const instance = this.fromLockingScript(utxo.script, {}, nopScript);
        instance.from = utxo;
        return instance;
    }
    next(opt) {
        const cloned = super.next(opt);
        cloned.prependNOPScript(this.getPrependNOPScript());
        return cloned;
    }
}
exports.BSV20V2 = BSV20V2;
__decorate([
    (0, scrypt_ts_1.prop)(true)
], BSV20V2.prototype, "id", void 0);
__decorate([
    (0, scrypt_ts_1.prop)()
    /** Max supply: max 2^64-1 */
], BSV20V2.prototype, "max", void 0);
__decorate([
    (0, scrypt_ts_1.prop)()
    /** Decimals: set decimal precision, defaults to 0. This is different from BRC20 which defaults to 18. */
], BSV20V2.prototype, "dec", void 0);
__decorate([
    (0, scrypt_ts_1.prop)()
    /** Decimals: set decimal precision, defaults to 0. This is different from BRC20 which defaults to 18. */
], BSV20V2.prototype, "sym", void 0);
__decorate([
    (0, scrypt_ts_1.method)()
], BSV20V2.prototype, "buildStateOutputFT", null);
__decorate([
    (0, scrypt_ts_1.method)()
], BSV20V2.prototype, "isGenesis", null);
__decorate([
    (0, scrypt_ts_1.method)()
], BSV20V2.prototype, "initId", null);
__decorate([
    (0, scrypt_ts_1.method)()
], BSV20V2, "buildTransferOutput", null);
__decorate([
    (0, scrypt_ts_1.method)()
], BSV20V2, "buildTransferScript", null);
__decorate([
    (0, scrypt_ts_1.method)()
], BSV20V2, "createTransferInsciption", null);
